module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "委员会名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1), _vm._v(" "), (_vm.params.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "缩略图"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（推荐尺寸500*280）"
    },
    on: {
      "imgChange": _vm.imgChange
    },
    model: {
      value: (_vm.params.thumbnail),
      callback: function($$v) {
        _vm.$set(_vm.params, "thumbnail", $$v)
      },
      expression: "params.thumbnail"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "缩略图",
      "prop": "thumbnail"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（推荐尺寸500*280）"
    },
    on: {
      "imgChange": _vm.imgChange
    },
    model: {
      value: (_vm.params.thumbnail),
      callback: function($$v) {
        _vm.$set(_vm.params, "thumbnail", $$v)
      },
      expression: "params.thumbnail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "介绍",
      "prop": "introduce"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "750px"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.params.introduce),
      callback: function($$v) {
        _vm.$set(_vm.params, "introduce", $$v)
      },
      expression: "params.introduce"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("停用")])], 1), _vm._v("\n                停用后，将不在官网上展示，自定义链接不支持访问\n\n        ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e901a314"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/professional_committee/add/src/subpage1.vue
// module id = 1583
// module chunks = 1